import { z } from 'zod';
// Union type to strictly type timestamp fields instead of using z.any()
export const FirestoreTimestamp = z.union([
    z.date(),
    z.string().datetime({ offset: true }).optional(), // ISO 8601 strings
    z.string().regex(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/).optional(),
    z.object({
        seconds: z.number(),
        nanoseconds: z.number()
    }),
    z.object({
        _seconds: z.number(),
        _nanoseconds: z.number()
    }),
    z.custom((val) => typeof val?.toDate === 'function', 'Invalid Firestore Timestamp')
]);
